import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Layout from "../../../components/layout/Layout";
import { Button } from "react-bootstrap";
import { blobURL } from "common/StringUtils";
import { Helmet } from "react-helmet";
import { mobileScroll } from "common/FunctionUtils";
import { LOCALES } from "common/constants";

const GoodWorkingConditions = () => {
  const checklistaEnglish = `${blobURL}/checklistEnglish.pdf`;
  const checklista = `${blobURL}/checklista.PDF`;
  const Accident = `${blobURL}/incident-or-accident.pdf`;
  const AccidentSwedish = `${blobURL}/incident-or-accident-Swedish.pdf`;

  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");

  const download_file = (fileURL, PdfName) => {
    // for non-IE
    if (!window.ActiveXObject) {
      let save = document.createElement("a");
      save.href = fileURL;
      save.target = "_blank";
      let filename = fileURL.substring(fileURL.lastIndexOf("/") + 1);
      save.download = PdfName || filename;
      if (
        navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
        navigator.userAgent.search("Chrome") < 0
      ) {
        document.location = save.href;
        // window event not working here
      } else {
        const evt = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        save.dispatchEvent(evt);
        (window.URL || window.webkitURL).revokeObjectURL(save.href);
      }
    }

    // for IE < 11
    else if (!window.ActiveXObject && document.execCommand) {
      let _window = window.open(fileURL, "_blank");
      _window.document.close();
      _window.document.execCommand("SaveAs", true, PdfName || fileURL);
      _window.close();
    }
  };

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    mobileScroll();
  }, []);

  return (
    <Layout
      className="p-4 my-customers-table good_conditions mt-5"
      showSidebar
      bgcolor
    >
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/good-working-conditions"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/bra-arbetsvillkor"
          />
        )}
      </Helmet>
      <div className="page-content">
        <div className="working-environment home-page">
          <section className="banner short-banner text-center mb-3 working_section">
            <div className="container">
              <h1 className="white">{t("Good working conditions")}</h1>
            </div>
          </section>
        </div>

        <div className="main_group_working">
          <div className="insurances-page ">
            <div className="insurances-text">
              <div>
                <div className="row">
                  <div className="col-sm-8 text-center m-auto">
                    <p className="working_txt">{t("goodwe")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-8 text-center m-auto">
            <h5 className="text-primary">
              {t("Click Below Buttons To Download Pdf")}
            </h5>
            <div className="working-btns">
              <Button
                variant="outline-primary"
                title={t("Click to download PDF")}
                className="cursor-pointer mt-2 mb-2 ml-2 mr-2"
                onClick={() => {
                  download_file(
                    language === LOCALES.EN_US
                      ? "/static/media/checklistEnglish.7bef249905eb4a33906c.pdf"
                      : "/static/media/checklista.82af3d9600f109120735.PDF",
                    "Check_your_work_environment"
                  );
                  window.open(
                    language === LOCALES.EN_US ? checklistaEnglish : checklista,
                    "_blank"
                  );
                }}
              >
                {t("Check your work environment")}
              </Button>
              <Button
                variant="outline-primary"
                title={t("Click to download PDF")}
                className="cursor-pointer mt-2 mb-2 ml-2 mr-2"
                onClick={() => {
                  download_file(
                    language === LOCALES.EN_US
                      ? "/static/media/incident-or-accident.f468afc64ab8d47b450f.pdf"
                      : "/static/media/incident-or-accident-Swedish.bd362fbedf5beef85948.pdf",
                    "Incident_Or_Accident"
                  );
                  window.open(
                    language === LOCALES.EN_US ? Accident : AccidentSwedish,
                    "_blank"
                  );
                }}
              >
                {t("Report incident or accident")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default GoodWorkingConditions;
